import { useState } from 'react';
import { useLanguage } from '../context/LanguageContext';
import './LeyPage.css';

const LAWYER_IMAGE_SRC = '/img/patriciaProfileWeb.png';
const WHATSAPP_URL = 'https://wa.me/5491132361805';
const FORMSPREE_ACTION = 'https://formspree.io/f/xreyolap';

function LeyPage() {
  const { t } = useLanguage();
  const [formData, setFormData] = useState({ name: '', email: '', phone: '', message: '' });

  const handleChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  return (
    <div className="ley-page">
      {/* Hero: lawyer placeholder (left) + branding (right) on white */}
      <section className="ley-hero">
        <a
          href="tel:+5491132361805"
          className="ley-hero__phone"
          title={t('ley.phoneCallTitle') || 'Call 9 11 3236-1805'}
          aria-label={t('ley.phoneCallTitle') || 'Call 9 11 3236-1805'}
        >
          {t('ley.phoneDisplay')}
        </a>
        <div className="ley-hero__inner">
          <div className="ley-hero__branding">
            <img src="/img/pfalconlogo.png" alt="Patricia Falcon Abogados" className="ley-hero__brand-logo ley-logo ley-logo--hero" />
            <div className="ley-hero__logo">
              <span className="ley-hero__logo-patricia">PATRICIA</span>
              <span className="ley-hero__logo-first">FALCON</span>
              <span className="ley-hero__logo-second">ABOGADOS</span>
            </div>
            <p className="ley-hero__endorsement">
              <span className="ley-hero__endorsement-voted">{t('ley.endorsementVoted')}</span>
              <span className="ley-hero__endorsement-best">{t('ley.endorsementBest')}</span>
              <span className="ley-hero__endorsement-rest">{t('ley.endorsementRest')}</span>
            </p>
          </div>
          <div className="ley-hero__image-wrap">
            <img
              src={LAWYER_IMAGE_SRC}
              alt=""
              className="ley-hero__image"
            />
          </div>
        </div>
      </section>

      {/* Stats & reviews - blue background */}
      <section className="ley-stats">
        <img src="/img/pfalconlogo.png" alt="" className="ley-stats__logo ley-logo ley-logo--stats" aria-hidden />
        <h2 className="ley-stats__title">{t('ley.statsTitle')}</h2>
        <p className="ley-stats__reviews">{t('ley.statsReviews')}</p>
        <div className="ley-stats__stars" aria-hidden="true">
          <span className="ley-stars__star" />
          <span className="ley-stars__star" />
          <span className="ley-stars__star" />
          <span className="ley-stars__star" />
          <span className="ley-stars__star" />
        </div>
        <h2 className="ley-stats__winning">{t('ley.statsWinning')}</h2>
      </section>

      {/* Call to action - opens WhatsApp */}
      <section className="ley-cta">
        <img src="/img/pfalconlogo.png" alt="" className="ley-cta__logo ley-logo ley-logo--cta" aria-hidden />
        <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="ley-cta__button">
          <span className="ley-cta__label">{t('ley.ctaLabel')}</span>
          <span className="ley-cta__sublabel">{t('ley.ctaSublabel')}</span>
          <span className="ley-cta__icon" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="currentColor" width="24" height="24" aria-hidden="true">
              <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
            </svg>
          </span>
        </a>
      </section>

      {/* Form section - white */}
      <section className="ley-form-section">
        <img src="/img/pfalconlogo.png" alt="" className="ley-form__logo ley-logo ley-logo--form" aria-hidden />
        <h2 className="ley-form__heading">{t('ley.formHeading')}</h2>
        <p className="ley-form__subheading">{t('ley.formSubheading')}</p>
        <form className="ley-form" action={FORMSPREE_ACTION} method="POST">
          <label className="ley-form__label">
            {t('ley.formNameLabel')}<span className="ley-form__required">*</span>
          </label>
          <input
            type="text"
            name="name"
            required
            className="ley-form__input"
            placeholder={t('ley.formNamePlaceholder')}
            value={formData.name}
            onChange={handleChange}
          />
          <label className="ley-form__label">
            {t('ley.formEmailLabel')}<span className="ley-form__required">*</span>
          </label>
          <input
            type="email"
            name="email"
            required
            className="ley-form__input"
            placeholder={t('ley.formEmailPlaceholder')}
            value={formData.email}
            onChange={handleChange}
          />
          <label className="ley-form__label">{t('ley.formPhoneLabel')}</label>
          <input
            type="tel"
            name="phone"
            className="ley-form__input"
            placeholder={t('ley.formPhonePlaceholder')}
            value={formData.phone}
            onChange={handleChange}
          />
          <label className="ley-form__label">{t('ley.formMessageLabel')}</label>
          <textarea
            name="message"
            className="ley-form__input ley-form__textarea"
            placeholder={t('ley.formMessagePlaceholder')}
            rows={4}
            value={formData.message}
            onChange={handleChange}
          />
          <button type="submit" className="ley-form__submit">
            {t('ley.formSubmit')}
          </button>
        </form>
      </section>
    </div>
  );
}

export default LeyPage;
